(function () {

  // Let's set some variables, shall we?
  var selectedCategory = 'all';
  var selectChooser = document.querySelector('.js-work-categories__select select');
  var tabsChooser = document.querySelectorAll('.js-work-categories__tabs li');

  // Ensure History.js is ready to go.
  if (!History.enabled)
  {
    console.log("WARNING: no history support");
    return false;
  }
  else
  {
    // Listen for changes to the page state
    History.Adapter.bind(window, 'statechange', function () {
      readPageState(false);
    });
  }

  // Initialize History.js
  function init() {
    readPageState(true);
  }

  // Do it.
  init();

  // This will remove the 'is-selected' class from any tab that has it
  function clearTabs() {
    Array.prototype.forEach.call(tabsChooser, function (el) {
      if (el.classList.contains('is-selected')) {
        el.classList.remove('is-selected');
      }
    });
  }

  // When the select element's value is changed
  selectChooser.addEventListener('change', function () {
    // Assign the selected value to the selectedCategory variable
    selectedCategory = this.value;

    // Set the History.js page state
    setPageState(this.value);

    // set the active tab
    setTab(selectedCategory)
  });

  // For each tab
  Array.prototype.forEach.call(tabsChooser, function (el) {
    // When it is clicked
    el.addEventListener('click', function () {

      // Set the History.js page state
      setPageState(el.getAttribute('data-value'));

      // Run this
      clearTabs();
      // Add the 'is-selected' class to it
      el.classList.add('is-selected');
      // Assign its value to the selectedCategory variable
      selectedCategory = el.getAttribute('data-value');
      // Change the nearby select element's value to whatever is now assigned to selectedCategory
      selectChooser.value = selectedCategory;
    });
  });

  // Set the active tab
  function setTab(selectedCategory)
  {
    // Run this
    clearTabs();
    // For each tab
    Array.prototype.forEach.call(tabsChooser, function (el) {
      // If it's data-value matches the selected category
      if (el.getAttribute('data-value') === selectedCategory) {
        // Add the 'is-selected' class
        el.classList.add('is-selected');
      }
    });
  }

  // Set the history.js page state
  function setPageState(filterBy)
  {
    // Make sure we have a filter
    if (filterBy && filterBy.length)
    {
      // If the filter is anything other than * push the category
      if (filterBy !== '*')
      {
        History.pushState(null, 'Tag Creative', '?category=' + filterBy);
      }
      else
      {
        History.pushState(null, 'Tag Creative', '/work');
      }


    }

  }

  // Gets query string parameters by name
  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex   = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  // Use History.js to read the current page state
  function readPageState(initialPageLoad) {
    // Read the current page state
    State = History.getState();

    // Get the category
    var cat = getParameterByName('category', State.url);

    // Make sure we have a category
    if (cat && cat.length)
    {
      // If this is our first page load, set the tab and select chooser
      if (initialPageLoad)
      {
        // Set the page tab
        setTab(cat);
        // Set the select
        selectChooser.value = cat;
      }
      // Create the filter class
      var filterBy = '.cat-' + cat;
      // Filter isotope
      grid.isotope({ filter: filterBy});
    }
    else
    {
      grid.isotope({ filter: '*'});
    }
  }
})();
